import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import { useEditorReturn } from '../../hooks/useEditorReturn';
import ContactEditor from './ContactEditor';

function AddContact() {
	const navigate = useNavigate();
	const params = useParams();
	const { id } = params;
	const location = useLocation();
	const route = location.pathname;
	const { returnTo } = useEditorReturn();

	// Extract IDs from route
	const preloadAccountId = route.includes('account') ? id : null;

	const backTo = preloadAccountId ? `/AdminScreen/accounts/account/${preloadAccountId}` : '/AdminScreen/contacts';

	const handleClose = () => {
		navigate(returnTo || backTo);
	};

	const handleSaved = () => {
		navigate(returnTo || backTo);
	};

	return (
		<EntityList>
			<Helmet>
				<title>Nuevo Contacto</title>
			</Helmet>
			<PageHead
				breadcrumb={
					preloadAccountId
						? [
							{ label: 'Inicio', to: '/AdminScreen' },
							{ label: 'Cuentas', to: '/AdminScreen/accounts' },
							{ label: 'Cuenta', to: backTo },
							{ label: 'Nuevo Contacto' },
						]
						: [
							{ label: 'Inicio', to: '/AdminScreen' },
							{ label: 'Contactos', to: '/AdminScreen/contacts' },
							{ label: 'Nuevo Contacto' },
						]
				}
				title='Nuevo Contacto'
				subtitle='Completá los datos principales del contacto.'
			/>
			<ContactEditor
				onClose={handleClose}
				onSaved={handleSaved}
				isEditing={false}
				cancelHandler={handleClose}
				preloadAccountId={preloadAccountId}
				allowCreateRoundTrip
			/>
		</EntityList>
	);
}
export default AddContact;
